import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const DEFAULT_STATE = {
  modal: {
    inquiry: false,
    request: false
  },
  request: {}
}

const state = JSON.parse(JSON.stringify(DEFAULT_STATE))

const mutations = {
  modalOpen(state, payload) {
    state.modal[payload] = true
  },
  modalOff(state, payload) {
    state.modal[payload] = false
  },
  resetState(state) {
    state.user = JSON.parse(JSON.stringify(DEFAULT_STATE.user))
  },
  request(state, payload) {
    state.request = payload
  }
}

const getters = {
  modal: state => {
    return state.modal
  },
  request: state => {
    if (state.request.period) {
      if (state.request.period.start) {
        state.request.period.start = new Date(state.request.period.start)
      }
      if (state.request.period.end) {
        state.request.period.end = new Date(state.request.period.end)
      }
    }
    return state.request
  }
}

const actions = {
  // increment10({ commit, state }) {
  //   state.count = state.count + 9
  //   commit('increment')
  // },
  // decrement10({ commit, state }) {
  //   state.count = state.count - 9
  //   commit('decrement')
  // }
  // incrementIfOdd ({ commit, state }) {
  //   if ((state.count + 1) % 2 === 0) {
  //     commit('increment')
  //   }
  // },
  // incrementAsync ({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     setTimeout(() => {
  //       commit('increment')
  //       resolve()
  //     }, 1000)
  //   })
  // }
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [createPersistedState({
    paths: [
      'request'
    ]
  })]
})

